import * as yup from 'yup'

import constants from 'constants/index'

const { AWAITING_REPLY_VALIDATION_STATUS_ID } = constants.tickets

const schema = yup.object().shape({
  content: yup.string().required(),
  statusId: yup
    .number()
    .oneOf(
      [AWAITING_REPLY_VALIDATION_STATUS_ID],
      'Envio permitido apenas com o status "Validar Resposta".',
    )
    .required(),
  attachments: yup.mixed().fileUpload(),
})

export default schema
